
/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class CreateScaffoldCommand {
  ScaffoldId: string;
  SpecificLocationDetails: string;
  Description: string;
  AdverseWeatherIndicator: boolean;
  SiteAreaId: string;
  ScaffoldNumber: string;
  ScaffoldStatusId: string;
  ContractId: string;
  DateOfNextInspection: string;
  OffsetFromUtc: number;
  OwnerId: string;
  Latitude: number;
  Longitude: number;
  ScaffoldingSystemId: string;
  MaximumTonnage: number;
  StandingTonnage: number;
  CommandVersion: string;
  SourceApp: string;
  SourceAppVersion: string;
}


